import { useState } from 'react';
import { DualGameBoard } from './components/DualGameBoard';
import { SingleGameBoard } from './components/SingleGameBoard';
import './App.css';

type GameMode = 'menu' | 'single' | 'dual';

function App() {
  const [gameMode, setGameMode] = useState<GameMode>('menu');

  const handleBackToMenu = () => setGameMode('menu');

  if (gameMode === 'menu') {
    return (
      <div className="app">
        <div className="main-menu">
          <h1 className="game-title">2048</h1>
          <p className="game-subtitle">选择游戏模式</p>

          <div className="mode-selection">
            <button className="mode-btn single-player" onClick={() => setGameMode('single')}>
              <span className="icon">👤</span>
              <span className="title">单人模式</span>
              <span className="desc">经典2048挑战</span>
            </button>

            <button className="mode-btn dual-player" onClick={() => setGameMode('dual')}>
              <span className="icon">👥</span>
              <span className="title">双人对战</span>
              <span className="desc">同键盘对战模式</span>
            </button>
          </div>

          <div className="menu-footer">
            <p className="hint">双人对战：左玩家用 WASD，右玩家用方向键</p>
          </div>
        </div>
      </div>
    );
  }

  if (gameMode === 'single') {
    return (
      <div className="app">
        <SingleGameBoard onBack={handleBackToMenu} />
      </div>
    );
  }

  if (gameMode === 'dual') {
    return (
      <div className="app dual-mode">
        <header className="game-header">
          <button className="back-btn" onClick={handleBackToMenu}>← 返回菜单</button>
          <h2>2048 双人对战</h2>
          <div className="spacer" />
        </header>
        <main className="game-main">
          <DualGameBoard />
        </main>
      </div>
    );
  }

  return null;
}

export default App;
